import { render } from "./WarrantyClaim.vue?vue&type=template&id=02055ddc&scoped=true&ts=true"
import script from "./WarrantyClaim.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarrantyClaim.vue?vue&type=script&setup=true&lang=ts"

import "./WarrantyClaim.vue?vue&type=style&index=0&id=02055ddc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02055ddc"],['__file',"src/components/scan/aftersale/WarrantyClaim.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02055ddc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02055ddc', __exports__)) {
    console.log('reload')
    api.reload('02055ddc', __exports__)
  }
  
  module.hot.accept("./WarrantyClaim.vue?vue&type=template&id=02055ddc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('02055ddc', render)
  })

}


export default __exports__